import { api, TAGS } from "@/store/api"
import {
  IAuthTokens,
  ISendEmailOtpPayload,
  ITelegramMiniAppLoginPayload,
  IVerifyEmailOtpPayload
} from "@/types/auth.types"

export const authAPI = api
  .enhanceEndpoints({ addTagTypes: [TAGS.AUTH] })
  .injectEndpoints({
    endpoints: (build) => ({
      sendEmailOtpLogin: build.mutation<void, ISendEmailOtpPayload>({
        query: (body) => ({
          url: "/auth/email/send-code/login",
          method: "POST",
          data: body
        })
      }),
      sendEmailOtpCreate: build.mutation<void, ISendEmailOtpPayload>({
        query: (body) => ({
          url: "/auth/email/send-code/create",
          method: "POST",
          data: body
        })
      }),
      verifyEmailOtp: build.mutation<IAuthTokens, IVerifyEmailOtpPayload>({
        query: (body) => ({
          url: "/auth/email/verify-code",
          method: "POST",
          data: body
        })
      }),
      loginWithTelegramMiniApp: build.mutation<
        IAuthTokens,
        ITelegramMiniAppLoginPayload
      >({
        query: (body) => ({
          url: "/auth/telegram/mini-app",
          method: "POST",
          data: body
        })
      }),
      logout: build.mutation<void, { refreshToken: string }>({
        query: (body) => ({
          url: "/auth/logout",
          method: "POST",
          data: body
        })
      })
    })
  })

export const {
  useSendEmailOtpLoginMutation,
  useSendEmailOtpCreateMutation,
  useVerifyEmailOtpMutation,
  useLoginWithTelegramMiniAppMutation,
  useLogoutMutation
} = authAPI
